import React, { Component } from "react";
import { Button, Checkbox, Form, Icon, Modal, Select } from "semantic-ui-react";
import { riceMill, multiFunction, longTail } from "assets/data/modelOption";
import { modelOption } from "assets/data/deviceModel";
import { UserContext } from "context/userProvider";
// import "scss/components/modals/customers/newCustomer.scss";
import Swal from "sweetalert2";
import SemanticDatepicker from "react-semantic-ui-datepickers";

export default class NewMachine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chkMember1: false,
      chkMember2: false,
      chkMember3: false,
      deviceList: [],
      deviceOptions: [],
      deviceType: [
        {
          type: "เครื่องสีข้าว และเครื่องคัดแยกเมล็ดพันธุ์ข้าว",
          enable: false,
          model: "",
          deviceserial: "",
          clpserial: "",
          devicebuydate: "",
          description: "",
        },
        {
          type: "เครื่องจักรกลทางการเกษตร(Model)",
          enable: false,
          model: "",
          deviceserial: "",
          clpserial: "",
          devicebuydate: "",
          description: "",
        },
        {
          type: "หางเรือ",
          enable: false,
          model: "",
          deviceserial: "",
          clpserial: "",
          devicebuydate: "",
          description: "",
        },
        {
          type: "อิ่นๆ",
          enable: false,
          model: "",
          deviceserial: "",
          clpserial: "",
          devicebuydate: "",
          description: "",
        },
      ],
      
    };
  }
  
  alertDialog = (title, text, icon) => {
    Swal.fire({
      title: title,
      text: text,
      icon: icon,
      confirmButton: "OK",
    }).then((res) => {
      // if (res.isConfirmed) {
      //   return this.props.isClose();
      // }
    });
  };

  onAddCustomer = async () => {
    console.log("chk1",this.chkMember1)
    console.log("chk2",this.chkMember2)
    console.log("chk3",this.chkMember3)
    if(this.chkMember1 === true || this.chkMember2 === true || this.chkMember3 === true){
      return this.alertDialog("Warning!", "ไม่สามารถบันทึกข้อมูลได้!!! เนื่องจากหมายเลขเครื่องจักรนี้ได้ทำการผูกข้อมูลแล้ว *กรุณาทำการยกเลิกหมายเลขเครื่องจักรจาก Uesr เก่าก่อนทำการบันทึก", "warning");
    }

    if (
      this.state.id === null ||
      this.state.name === null ||
      this.state.deviceTypes === null   
    )
    return this.alertDialog("Warning!", "กรุณากรอกข้อมูลที่มีเครื่องหมาย * ให้ครบถ้วน", "warning");   
    
    let deviceOptions = this.state.deviceType.filter(
      (device) => device.enable === true
    );

    const customerDetail = this.props.data || null ;
    const data = {
      id: customerDetail?.id,
      name: customerDetail?.name,
      phone_no: customerDetail?.phone_no,
      deviceTypes: deviceOptions,
    };

    // console.log("datasave:",data)
    let result = await this.context.userNewDevice(data);
    if (result != null) {
      if (result?.result === "success") {
        await this.context.getCustomers({ team_id: -1, role: "" });
        return this.alertDialog("สำเร็จ!","เพิ่มข้อมูลเครื่องจักรสำเร็จ",result?.result);
      } else return this.alertDialog("ผิดพลาด!", "เพิ่มข้อมูลเครื่องจักรไม่สำเร็จ", "error");
    } else return this.alertDialog("ผิดพลาด!", "เพิ่มข้อมูลเครื่องจักรไม่สำเร็จ", "error");
  };

  onUpdateTime = (date) => {
    if (date) {
      let updateDate =
        date
          .toLocaleDateString("ko-KR", { year: "numeric", month: "2-digit", day: "2-digit" })
          .replace(/\./g, "-")
          .replace(/\s/g, "")
          .slice(0, -1);
      return updateDate;
    }
    return null; // หรือคืนค่าที่ต้องการให้เหมาะสมในกรณีที่ date เป็น null
  };

  getClpMember = async () => {
    const clpMemberList = await this.context.getClpMember();
    console.log("clpMemberList", clpMemberList);
    // this.setState({ clpMemberList: clpMemberList });
    return clpMemberList;
  };

  updateDeviceType = (e, idx) => {
    const { deviceType } = this.state;
    // TOGGLE ENABLE STATUS
    deviceType[idx]["enable"] = !deviceType[idx]["enable"];
    this.setState({ deviceType: deviceType });
  };

  getDeviceData = async (model, string) => {
    try {
      if (string == "model") {
        // เรียกใช้ฟังก์ชัน getDevice จาก context เพื่อดึงข้อมูลอุปกรณ์
        const deviceList = await this.context.getDevice();
        // อัปเดตค่า deviceList ใน state ของคอนเท็กซ์
        this.setState({ deviceList });
        console.log("deviceList", deviceList);
        const models = model
        const deviceOptions = deviceList
          .filter((device) => device.model === models) // กรองอุปกรณ์ที่มี model ตรงกับค่าที่ส่งมา
          .map((device) => ({
            key: device.clp_serial,
            value: device.clp_serial,
            text: device.clp_serial,
          }));
        this.setState({ deviceOptions });
        this.setState({ models });

        const iotOptions = deviceList
          .filter((device) => device.clp_serial === model)
          .map((device) => ({
            key: device.deviceSerial,
            value: device.deviceSerial,
            text: device.deviceSerial,
          }));
        this.setState({ iotOptions });
      }
      if (string == "clp") {
        const deviceList = this.state.deviceList;
        const models = this.state.models;
        const iotOptions = deviceList
          .filter((device) => device.clp_serial === model && device.model === models)
          .map((device) => ({
            key: device.deviceSerial,
            value: device.deviceSerial,
            text: device.deviceSerial,
          }));
        this.setState({ iotOptions });        
      }
    } catch (error) {
      console.log(error);
    }
  };

  createCustomerDetail = () => { 
    const customerDetail = this.props.data || null ;
    // const usernameRegex = /^([a-zA-Z0-9])+$/;
    const { deviceType } = this.state;
    const riceMillOptions = riceMill.map((device) => ({
      key: device,
      value: device,
      text: device,
    }));
    const multiFunctionOptions = multiFunction.map((device) => ({
      key: device,
      value: device,
      text: device,
    }));
    const longTailOptions = longTail.map((device) => ({
      key: device,
      value: device,
      text: device,
    }));
    const modelOptions = modelOption.map((model) => ({
      key: model,
      value: model,
      text: model,
    }));

    return (
      <table>
        <tbody>
         <tr>
            <td>
                ชื่อบัญชีผู้ใช้งาน
            </td>
              <td>
                <Form.Input
                  type="text"
                  placeholder="ชื่อบัญชีผู้ใช้งาน"
                  value={customerDetail ?customerDetail.id : ""}
                  readOnly
                />
              </td>
            </tr>

          <tr>
            <td>
                ชื่อ-นามสกุล
            </td>
            <td>
             <Form.Input
                type="text"
                placeholder="ชื่อ-นามสกุล"
                value={customerDetail ?customerDetail.name : ""}
                readOnly
               />
            </td>
          </tr>

          <tr>
            <td>
                เบอร์โทร
            </td>
            <td>
             <Form.Input
                type="text"
                placeholder="เบอร์โทร"
                value={customerDetail ?customerDetail.phone_no : ""}
                readOnly
               />
            </td>
          </tr>
          
          <tr>
            <td>
              ประเภทเครื่องจักร<span style={{ color: "#ff0000" }}>*</span>
            </td>
            <td>
              <Form.Field
                control={Checkbox}
                label={<label>เครื่องสีข้าว,เครื่องคัดแยกเมล็ดพันธุ์</label>}
                checked={deviceType[0].enable === true}
                onChange={(e) => this.updateDeviceType(e, 0)}
              />
              {deviceType[0].enable === true && (
                <>
                  <Form>
                  <Form.Field
                      control={Select}
                      options={modelOptions}
                      placeholder="รุ่นเครื่องสีข้าว,เครื่องคัดแยกเมล็ดพันธุ์"
                      search
                      onChange={(e, { value }) => {
                        deviceType[0]["model"] = value;
                        this.getDeviceData(value, "model");
                      }}
                    />
                    <Form.Field
                      control={Select}
                      options={this.state.deviceOptions}
                      placeholder="หมายเลขเครื่องจักร"
                      search
                      onChange={(e, { value }) => {
                        deviceType[0]["clpserial"] = value;
                        this.getDeviceData(value, "clp");
                      }}
                    />
                    <Form.Field
                      control={Select}
                      options={this.state.iotOptions}
                      placeholder="หมายเลขอุปกรณ์ IoT"
                      search
                      onChange={(e, { value }) => {
                        deviceType[0]["deviceserial"] = value;

                        let MemberList;
                        this.getClpMember().then((result) => {                         
                          MemberList = result;
                          const chkMember = MemberList.filter((member) =>
                            member.model === deviceType[0]["model"] &&
                            member.clp_serial === deviceType[0]["clpserial"] &&
                            member.device_serial === deviceType[0]["deviceserial"]
                          );
                          
                          if (chkMember.length > 0) {
                            this.chkMember1 = true;
                            return this.alertDialog("พบปัญหา!", "หมายเลขเครื่อง" + " " + deviceType[0]["deviceserial"] + " " +
                              "ได้มีการผูกข้อมูลเครื่องไว้ที่ User" + " " + "[" + chkMember[0].username + "]" + " " + "กรุณาตรวจสอบข้อมูลอีกครั้ง", "warning");
                          }
                          else {
                            this.chkMember1 = false;
                          }
                        });
                      }}
                    />
                    <Form.Field>
                      <SemanticDatepicker
                        placeholder="วันที่ซื้อเครื่อง"
                        format="DD-MM-YYYY"
                        search
                        onChange={(e, { value }) => {
                          deviceType[0]["devicebuydate"] = this.onUpdateTime(value);
                        }}                       
                      />
                    </Form.Field>
                    <Form.TextArea
                      placeholder="หมายเหตุ"
                      onChange={(e) => {
                        deviceType[0]["description"] = e.target.value;
                      }}
                    ></Form.TextArea>
                  </Form>
                </>
              )}
            </td>
          </tr>

          <tr>
            <td></td>
            <td>
              <Form.Field
                control={Checkbox}
                label={<label>เครื่องจักรกลทางการเกษตร(Model)</label>}
                checked={deviceType[1].enable === true}
                onChange={(e) => this.updateDeviceType(e, 1)}
              />
              {deviceType[1].enable === true && (
                <>
                  <Form>
                  <Form.Field
                      control={Select}
                      options={modelOptions}
                      placeholder="รุ่นเครื่องจักรกลทางการเกษตร"
                      search
                      onChange={(e, { value }) => {
                        deviceType[1]["model"] = value;
                        this.getDeviceData(value, "model");
                      }}
                    />
                    <Form.Field
                      control={Select}
                      options={this.state.deviceOptions}
                      placeholder="หมายเลขเครื่องจักร"
                      search
                      onChange={(e, { value }) => {
                        deviceType[1]["clpserial"] = value;
                        this.getDeviceData(value, "clp");
                      }}
                    />
                    <Form.Field
                      control={Select}
                      options={this.state.iotOptions}
                      placeholder="หมายเลขอุปกรณ์ IoT"
                      search
                      onChange={(e, { value }) => {
                        deviceType[1]["deviceserial"] = value;

                        let MemberList;
                        this.getClpMember().then((result) => {                         
                          MemberList = result;
                          const chkMember = MemberList.filter((member) =>
                            member.model === deviceType[1]["model"] &&
                            member.clp_serial === deviceType[1]["clpserial"] &&
                            member.device_serial === deviceType[1]["deviceserial"]
                          );
                          
                          if (chkMember.length > 0) {
                            this.chkMember2 = true;
                            return this.alertDialog("พบปัญหา!", "หมายเลขเครื่อง" + " " + deviceType[1]["deviceserial"] + " " +
                              "ได้มีการผูกข้อมูลเครื่องไว้ที่ User" + " " + "[" + chkMember[0].username + "]" + " " + "กรุณาตรวจสอบข้อมูลอีกครั้ง", "warning");
                          }
                          else {
                            this.chkMember2 = false;
                          }
                        });                       
                      }}
                    />
                    <Form.Field>
                      <SemanticDatepicker
                        placeholder="วันที่ซื้อเครื่อง"
                        format="DD-MM-YYYY"
                        search
                        onChange={(e, { value }) => {
                          deviceType[1]["devicebuydate"] = this.onUpdateTime(value);
                        }}                       
                      />
                    </Form.Field>
                    <Form.TextArea
                      placeholder="หมายเหตุ"
                      onChange={(e) => {
                        deviceType[1]["description"] = e.target.value;
                      }}
                    ></Form.TextArea>
                  </Form>
                </>
              )}
            </td>
          </tr>

          <tr>
            <td></td>
            <td>
              <Form.Field
                control={Checkbox}
                label={<label>หางเรือ</label>}
                checked={deviceType[2].enable === true}
                onChange={(e) => this.updateDeviceType(e, 2)}
              />
              {deviceType[2].enable === true && (
                <>
                  <Form>
                  <Form.Field
                      control={Select}
                      options={modelOptions}
                      placeholder="รุ่นหางเรือ"
                      search
                      onChange={(e, { value }) => {
                        deviceType[2]["model"] = value;
                        this.getDeviceData(value, "model");
                      }}
                    />
                    <Form.Field
                      control={Select}
                      options={this.state.deviceOptions}
                      placeholder="หมายเลขเครื่องจักร"
                      search
                      onChange={(e, { value }) => {
                        deviceType[2]["clpserial"] = value;
                        this.getDeviceData(value, "clp");
                      }}
                    />
                    <Form.Field
                      control={Select}
                      options={this.state.iotOptions}
                      placeholder="หมายเลขอุปกรณ์ IoT"
                      search
                      onChange={(e, { value }) => {
                        deviceType[2]["deviceserial"] = value;

                        let MemberList;
                        this.getClpMember().then((result) => {                         
                          MemberList = result;
                          const chkMember = MemberList.filter((member) =>
                            member.model === deviceType[2]["model"] &&
                            member.clp_serial === deviceType[2]["clpserial"] &&
                            member.device_serial === deviceType[2]["deviceserial"]
                          );
                          
                          if (chkMember.length > 0) {
                            this.chkMember3 = true;
                            return this.alertDialog("พบปัญหา!", "หมายเลขเครื่อง" + " " + deviceType[2]["deviceserial"] + " " +
                              "ได้มีการผูกข้อมูลเครื่องไว้ที่ User" + " " + "[" + chkMember[0].username + "]" + " " + "กรุณาตรวจสอบข้อมูลอีกครั้ง", "warning");
                          }
                          else {
                            this.chkMember3 = false;
                          }
                        });
                      }}
                    />
                    <Form.Field>
                      <SemanticDatepicker
                        placeholder="วันที่ซื้อเครื่อง"
                        format="DD-MM-YYYY"
                        search
                        onChange={(e, { value }) => {
                          deviceType[2]["devicebuydate"] = this.onUpdateTime(value);
                        }}                       
                      />
                    </Form.Field>
                    <Form.TextArea
                      placeholder="หมายเหตุ"
                      onChange={(e) => {
                        deviceType[2]["description"] = e.target.value;
                      }}
                    ></Form.TextArea>
                  </Form>
                </>
              )}
            </td>
          </tr>

          <tr>
            <td></td>
            <td>
              <Form.Field
                control={Checkbox}
                label={<label>อิ่นๆ</label>}
                checked={deviceType[3].enable === true}
                onChange={(e) => this.updateDeviceType(e, 3)}
              />
              {deviceType[3].enable === true && (
                <>
                  <Form>
                  <Form.Field
                      control={Select}
                      options={modelOptions}
                      placeholder="รุ่นอิ่นๆ"
                      search
                      onChange={(e, { value }) => {
                        deviceType[3]["model"] = value;
                        this.getDeviceData(value, "model");
                      }}
                    />
                    <Form.Field
                      control={Select}
                      options={this.state.deviceOptions}
                      placeholder="หมายเลขเครื่องจักร"
                      search
                      onChange={(e, { value }) => {
                        deviceType[3]["clpserial"] = value;
                        this.getDeviceData(value, "clp");
                      }}
                    />
                    <Form.Field
                      control={Select}
                      options={this.state.iotOptions}
                      placeholder="หมายเลขอุปกรณ์ IoT"
                      search
                      onChange={(e, { value }) => {
                        deviceType[3]["deviceserial"] = value;
                      }}
                    />
                    <Form.Field>
                      <SemanticDatepicker
                        placeholder="วันที่ซื้อเครื่อง"
                        format="DD-MM-YYYY"
                        search
                        onChange={(e, { value }) => {
                          deviceType[3]["devicebuydate"] = this.onUpdateTime(value);
                        }}                       
                      />
                    </Form.Field>
                    <Form.TextArea
                      placeholder="หมายเหตุ"
                      onChange={(e) => {
                        deviceType[3]["description"] = e.target.value;
                      }}
                    ></Form.TextArea>
                  </Form>
                </>
              )}
            </td>
          </tr>
        </tbody>
      </table>
    );
  };
  render() {
    return (
      <Modal
        closeIcon
        open={this.props.isOpen}
        onClose={() => this.props.isClose()}
      >
        <Modal.Header>
          <Icon name="user plus" />
          &ensp;เพิ่มสินค้าใหม่
        </Modal.Header>
        <Modal.Content scrolling>{this.createCustomerDetail()}</Modal.Content>
        <Modal.Actions>
          <Button basic negative onClick={() => this.props.isClose()}>
            ยกเลิก
          </Button>
          <Button color="twitter" onClick={() => this.onAddCustomer()}>
            บันทึก
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
NewMachine.contextType = UserContext;
